import React from "react";
import { Message } from "components/Atoms/Message";

interface IProps {
  message?: string
}

class Error extends React.PureComponent<IProps, any> {
  public render(): JSX.Element {
    const { message } = this.props;

    return (
      <Message type="error" className="margin-top-big">
        {message || RESX.GeneralLabels.SomethingUnexpectedHappened}
      </Message>
    );
  }
}

export default Error;
